var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"labels",class:{
    reverse: _vm.isReversedLayout,
  }},[(!_vm.isMindAlte)?_c('label',{staticClass:"label"},[_vm._v("\n    裏\n  ")]):_vm._e(),_c('label',{staticClass:"label"},[_vm._v("\n    表\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }